import React, { useState } from "react";
import type { TableProps } from "antd";
import {
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Table,
  Button,
  Slider,
  Switch,
  Radio,
  Checkbox,
  DatePicker,
  Select,
} from "antd";
import { EditableCellProps, Item } from "./Type";

const originData: Item[] = [];

const onChange = (value: string) => {
  console.log(`selected ${value}`);
};

const onSearch = (value: string) => {
  console.log("search:", value);
};

const filterOption = (
  input: string,
  option?: { label: string; value: string }
) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "number" ? (
      <InputNumber />
    ) : inputType === "select" ? (
      <Select
        showSearch
        placeholder="Select a person"
        optionFilterProp="children"
        onChange={onChange}
        onSearch={onSearch}
        filterOption={filterOption}
        options={[
          {
            value: "jack",
            label: "Jack",
          },
          {
            value: "lucy",
            label: "Lucy",
          },
          {
            value: "tom",
            label: "Tom",
          },
        ]}
      />
    ) : inputType === "text" ? (
      <Input />
    ) : inputType === "date" ? (
      <DatePicker />
    ) : inputType === "checkbox" ? (
      <Checkbox />
    ) : inputType === "radio" ? (
      <Radio.Group
        options={[
          { label: "Option 1", value: 1 },
          { label: "Option 2", value: 2 },
        ]}
      />
    ) : inputType === "switch" ? (
      <Switch />
    ) : inputType === "slider" ? (
      <Slider />
    ) : null;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

function TableDataCopy() {
  const [form] = Form.useForm();
  const [data, setData] = useState(originData);
  const [editingKey, setEditingKey] = useState("");
  const [count, setCount] = useState(2);

  const isEditing = (record: Item) => record.key === editingKey;

  const edit = (record: Partial<Item> & { key: React.Key }) => {
    form.setFieldsValue({ name: "", age: "", address: "", ...record });
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (key: React.Key) => {
    try {
      const row = (await form.validateFields()) as Item;

      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const deleteRow = (key: React.Key) => {
    const newData = data.filter((item) => item.key !== key);
    setData(newData);
  };

  const addNewRow = () => {
    const newRow: Item = {
      key: count.toString(),
      Series: `1`,
      ItemCode: "",
      ProductName: `اضف اسم الصنف	`,
      Unit: `الوحده`,
      Quantity: `الكميه`,
      Price: `السعر`,
      DiscountPercentage: `نسبه الخصم	`,
      DiscountValue: `قيمه الخصم	`,
      AddedTax: `ضريبه مضافه	`,
      Value: `قيمه`,
      Total: `الاجمالي`,
      comments: `ملاحظات`,
      StoreName: `اسم المخزن`,
      ItemBalance: `رصيد الصنف	`,
      CostCenter: `مركز التكلفه	`,
    };
    setData([...data, newRow]);
    edit(newRow);
    setCount(count + 1);
  };

  const columns = [
    {
      title: "م",
      dataIndex: "Series",
      width: 20,
      editable: false,
    },
    {
      title: "كود الصنف",
      dataIndex: "ItemCode",
      width: 130,
      editable: true,
    },
    {
      title: "اسم الصنف",
      dataIndex: "ProductName",
      width: 170,
      editable: true,
    },
    {
      title: "الوحده",
      dataIndex: "Unit",
      width: 80,
      editable: true,
    },
    {
      title: "الكميه",
      dataIndex: "Quantity",
      width: 100,
      editable: true,
    },
    {
      title: "السعر",
      dataIndex: "Price",
      width: 100,
      editable: true,
    },
    {
      title: "نسبه الخصم",
      dataIndex: "DiscountPercentage",
      width: 100,
      editable: true,
    },
    {
      title: "قيمه الخصم",
      dataIndex: "DiscountValue",
      width: 100,
      editable: true,
    },
    {
      title: "ضريبه مضافه",
      dataIndex: "AddedTax",
      width: 100,
      editable: true,
    },
    {
      title: "قيمه",
      dataIndex: "Value",
      width: 80,
      editable: true,
    },
    {
      title: "الاجمالي",
      dataIndex: "Total",
      width: 80,
      editable: true,
    },
    {
      title: "ملاحظات",
      dataIndex: "comments",
      width: 200,
      editable: true,
    },
    {
      title: "اسم المخزن",
      dataIndex: "StoreName",
      width: 120,
      editable: true,
    },
    {
      title: "رصيد الصنف",
      dataIndex: "ItemBalance",
      width: 100,
      editable: true,
    },
    {
      title: "مركز التكلفه",
      dataIndex: "CostCenter",
      width: 100,
      editable: true,
    },
    {
      title: "operation",
      dataIndex: "operation",
      width: 140,
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        return editable ? (
          <div className="grid grid-cols-2 gap-2">
            <Button onClick={() => save(record.key)} style={{ marginRight: 8 }}>
              Save
            </Button>

            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <Button>Cancel</Button>
            </Popconfirm>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => edit(record)}
              style={{ marginRight: 8 }}
              disabled={editingKey !== ""}
            >
              Edit
            </Button>

            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => deleteRow(record.key)}
            >
              <Button danger>Delete</Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const mergedColumns: TableProps["columns"] = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: Item) => ({
        record,
        inputType:
          col.dataIndex === "ItemCode"
            ? "select"
            : col.dataIndex === "ProductName"
            ? "select"
            : col.dataIndex === "Unit"
            ? "text"
            : col.dataIndex === "Quantity"
            ? "text"
            : col.dataIndex === "Price"
            ? "text"
            : col.dataIndex === "DiscountPercentage"
            ? "text"
            : col.dataIndex === "DiscountValue"
            ? "text"
            : col.dataIndex === "AddedTax"
            ? "text"
            : col.dataIndex === "Value"
            ? "text"
            : col.dataIndex === "Total"
            ? "text"
            : col.dataIndex === "comments"
            ? "text"
            : col.dataIndex === "StoreName"
            ? "text"
            : col.dataIndex === "StoreName"
            ? "text"
            : col.dataIndex === "ItemBalance"
            ? "text"
            : col.dataIndex === "CostCenter"
            ? "select"
            : null,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Form form={form} component={false}>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 items-center gap-2 my-5">
        <Button onClick={addNewRow} type="primary">
          اضافه
        </Button>
        <Button type="primary">اضافه مخزن</Button>
        <Button type="primary">قائمه اسعار</Button>
      </div>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={data}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
        scroll={{ x: 2500, y: 300 }}
      />
    </Form>
  );
}

export default TableDataCopy;
